/**
 * Tracks play and progress events on media elements
 * and pushes them to GTM. Events are pushed at
 * 0%, 25%, 50%, 75%, and 100%.
 * @param {HTMLAudioElement | HTMLVideoElement} mediaEl - Media element
 * @param {string} title - Title to identify media element in GTM
 */
function trackMediaEvents(mediaEl, title) {
  if (!mediaEl || !title) {
    console.warn("trackMediaEvents call is missing required arguments");
    return;
  }

  let mediaElType;
  if (mediaEl instanceof HTMLVideoElement) {
    mediaElType = "video";
  } else if (mediaEl instanceof HTMLAudioElement) {
    mediaElType = "audio";
  } else {
    console.warn(
      "Unexpected element passed to trackMediaEvents. Expected HTMLVideoElement or HTMLAudioElement",
    );
    return null;
  }

  window.dataLayer = window.dataLayer || [];
  const progressThresholds = [0, 25, 50, 75, 100];
  const progressEventsFired = new Set();

  function pushMediaEvent(progress) {
    window.dataLayer.push({
      event: mediaElType,
      status: progress === 0 ? "play" : "progress",
      progress,
      title,
    });
  }

  function handleTimeUpdate() {
    if (mediaEl.seeking || (mediaEl.paused && !mediaEl.ended)) return;

    const currentTime = mediaEl.currentTime;
    const duration = mediaEl.duration;
    const percentPlayed = (currentTime / duration) * 100;

    for (const threshold of progressThresholds) {
      if (
        !progressEventsFired.has(threshold) &&
        percentPlayed >= threshold &&
        percentPlayed < threshold + 25
      ) {
        progressEventsFired.add(threshold);
        pushMediaEvent(threshold);
      }
    }
  }

  mediaEl.addEventListener("timeupdate", handleTimeUpdate);
}

export default trackMediaEvents;
